import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../data/translations';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState('en');

    // Load saved language preference
    useEffect(() => {
        const savedLang = localStorage.getItem('language');
        if (savedLang && ['en', 'no'].includes(savedLang)) {
            setLanguage(savedLang);
        }
    }, []);

    // Toggle language
    const toggleLanguage = () => {
        const newLang = language === 'en' ? 'no' : 'en';
        setLanguage(newLang);
        localStorage.setItem('language', newLang);
    };

    // Translation helper function
    // Usage: t('nav.home') -> "Home" (or "Hjem")
    const t = (key) => {
        const keys = key.split('.');
        let value = translations[language];

        for (const k of keys) {
            value = value?.[k];
        }

        return value || key; // Fallback to key if not found
    };

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};
